import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Label,
  Loader,
  Message,
  Segment,
  Table,
  Form,
  Modal,
  Dropdown,

} from "semantic-ui-react";

import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
  writeBatch,
} from "firebase/firestore";

import moment from "moment";

import { db } from "../firebase/firebaseConfig";
import { UserContext } from "../context/UserContext";

const GestionGarantiaExterna = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { users } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [ingreso, setIngreso] = useState(null);
  const [garantia, setGarantia] = useState(null);
  const [savingModalidad, setSavingModalidad] = useState(false);
  const [openEnvio, setOpenEnvio] = useState(false);
  const [guiaEnvio, setGuiaEnvio] = useState("");
  const [observacionEnvio, setObservacionEnvio] = useState("");
  const [savingEnvio, setSavingEnvio] = useState(false);
  const [openRecepcionProveedor, setOpenRecepcionProveedor] = useState(false);
  const [observacionRecepcion, setObservacionRecepcion] = useState("");
  const [savingRecepcion, setSavingRecepcion] = useState(false);
  const [openSeguimiento, setOpenSeguimiento] = useState(false);
  const [nuevoEstadoProveedor, setNuevoEstadoProveedor] = useState("");
  const [observacionSeguimiento, setObservacionSeguimiento] = useState("");
  const [savingSeguimiento, setSavingSeguimiento] = useState(false);
  const [bitacoraProveedor, setBitacoraProveedor] = useState([]);
  // Modales Retiro proveedores
  const [openRecepcionST, setOpenRecepcionST] = useState(false);
  const [observacionRecepcionST, setObservacionRecepcionST] = useState("");
  const [savingRecepcionST, setSavingRecepcionST] = useState(false);
  // Secciones desplegables
  const [showDetalles, setShowDetalles] = useState(false);
  const [showHistorial, setShowHistorial] = useState(false);
  const [showDocumentos, setShowDocumentos] = useState(false);
  // CARGAR INGRESO
  const cargarIngreso = useCallback(async () => {
    if (!users?.emp_id || !id) return null;

    const qIngreso = query(
      collection(db, "ingresostcab"),
      where("emp_id", "==", users.emp_id)
    );

    const snap = await getDocs(qIngreso);

    const rows = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return (
      rows.find((item) => item.id === id) ||
      null
    );
  }, [users?.emp_id, id]);

  // CARGAR GARANTÍA EXTERNA
  const cargarGarantiaExterna = useCallback(async () => {
    if (!users?.emp_id || !id) return null;

    const qGarantia = query(
      collection(db, "garantiasexternas"),
      where("emp_id", "==", users.emp_id),
      where("id_cab_inst", "==", id)
    );

    const snap = await getDocs(qGarantia);

    if (snap.empty) return null;

    return {
      id: snap.docs[0].id,
      ...snap.docs[0].data(),
    };
  }, [users?.emp_id, id]);


  const cargarBitacoraProveedor = useCallback(
    async (idGarantiaExterna) => {
      if (!users?.emp_id || !idGarantiaExterna) {
        setBitacoraProveedor([]);
        return;
      }

      try {
        const qBitacora = query(
          collection(db, "garantiasexternasbitacora"),
          where("emp_id", "==", users.emp_id),
          where(
            "id_garantia_externa",
            "==",
            idGarantiaExterna
          )
        );

        const snap = await getDocs(qBitacora);

        const rows = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        rows.sort((a, b) => {
          const fechaA =
            a.fecha?.toDate?.()?.getTime?.() ?? 0;

          const fechaB =
            b.fecha?.toDate?.()?.getTime?.() ?? 0;

          return fechaB - fechaA;
        });

        setBitacoraProveedor(rows);
      } catch (error) {
        console.error(
          "Error cargando bitácora proveedor:",
          error
        );

        setBitacoraProveedor([]);
      }
    },
    [users?.emp_id]
  );

  // CARGA GENERAL
  const cargarDatos = useCallback(async () => {
    setLoading(true);

    try {
      const [ingresoActual, garantiaActual] = await Promise.all([
        cargarIngreso(),
        cargarGarantiaExterna(),
      ]);

      if (ingresoActual) {
        setIngreso(ingresoActual);
      }

      if (garantiaActual) {
        setGarantia(garantiaActual);

        await cargarBitacoraProveedor(
          garantiaActual.id
        );
      } else {
        setGarantia(null);
        setBitacoraProveedor([]);
      }
    } catch (error) {
      console.error(
        "Error cargando gestión garantía externa:",
        error
      );
    } finally {
      setLoading(false);
    }
  }, [
    cargarIngreso,
    cargarGarantiaExterna,
    cargarBitacoraProveedor,
  ]);

  useEffect(() => {
    cargarDatos();
  }, [cargarDatos]);

  // ESTADO VISUAL
  const estadoUI = useMemo(() => {
    const estado =
      garantia?.estado || "SIN ESTADO";

    switch (estado) {
      case "PENDIENTE_GESTION":
        return {
          color: "yellow",
          icon: "clock outline",
          text: "Pendiente gestión",
        };

      case "ENVIADO_PROVEEDOR":
        return {
          color: "blue",
          icon: "shipping fast",
          text: "Enviado a proveedor",
        };

      case "RECIBIDO_PROVEEDOR":
        return {
          color: "teal",
          icon: "inbox",
          text: "Recibido por proveedor",
        };

      case "EN_DIAGNOSTICO":
        return {
          color: "orange",
          icon: "search",
          text: "En diagnóstico",
        };

      case "EN_REPARACION":
        return {
          color: "violet",
          icon: "wrench",
          text: "En reparación",
        };

      case "EN_PRUEBAS":
        return {
          color: "purple",
          icon: "check circle outline",
          text: "En pruebas",
        };

      case "LISTO_RETIRO":
        return {
          color: "green",
          icon: "check circle",
          text: "Listo para retiro",
        };

      case "CERRADO":
        return {
          color: "grey",
          icon: "archive",
          text: "Cerrado",
        };

      default:
        return {
          color: "grey",
          icon: "question circle",
          text: estado,
        };
    }
  }, [garantia]);

  // ============================================================
  // FECHA
  // ============================================================

  const fecha = (valor) => {
    if (!valor) return "—";

    try {
      if (valor?.toDate) {
        return moment(
          valor.toDate()
        ).format("DD/MM/YYYY HH:mm");
      }

      return moment(valor).format(
        "DD/MM/YYYY HH:mm"
      );
    } catch {
      return "—";
    }
  };

  // ============================================================
  // LOADING
  // ============================================================

  if (loading) {
    return (
      <Container
        style={{
          paddingTop: 60,
          textAlign: "center",
        }}
      >
        <Loader active inline="centered">
          Cargando garantía externa...
        </Loader>
      </Container>
    );
  }

  // ============================================================
  // SIN CASO
  // ============================================================

  if (!garantia) {
    return (
      <Container
        style={{
          maxWidth: 1200,
          paddingTop: 30,
        }}
      >
        <Message negative>
          <Message.Header>
            No existe garantía externa
          </Message.Header>

          <p>
            No se encontró un caso de garantía
            externa asociado a este ingreso.
          </p>
        </Message>

        <Button
          icon
          labelPosition="left"
          onClick={() => navigate(-1)}
        >
          <Icon name="arrow left" />
          Volver
        </Button>
      </Container>
    );
  }

  // ============================================================
  // DEFINIR MODALIDAD DE ATENCIÓN
  // ============================================================

  const definirModalidadAtencion = async (modalidad) => {
    if (!garantia?.id) {
      await Swal.fire({
        icon: "error",
        title: "Garantía no encontrada",
        text: "No existe un caso de garantía externa válido.",
      });

      return;
    }

    let titulo = "";
    let descripcion = "";

    switch (modalidad) {
      case "ESPERA_REPARACION":
        titulo = "Cliente espera reparación";
        descripcion =
          "El cliente no recibirá un equipo de reemplazo mientras el equipo original se encuentra en reparación.";
        break;

      case "PRESTAMO_TEMPORAL":
        titulo = "Préstamo temporal";
        descripcion =
          "Se entregará temporalmente un equipo disponible mientras se repara el equipo original.";
        break;

      case "REEMPLAZO_DEFINITIVO":
        titulo = "Reemplazo definitivo";
        descripcion =
          "Se entregará otro equipo de manera definitiva y el equipo original no volverá al cliente.";
        break;

      default:
        return;
    }

    const result = await Swal.fire({
      icon: "question",
      title: titulo,
      text: descripcion,
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    });

    if (!result.isConfirmed) {
      return;
    }

    setSavingModalidad(true);

    try {
      const ahora = new Date();

      let requiereReemplazo = false;
      let tipoReemplazo = "";

      if (modalidad === "PRESTAMO_TEMPORAL") {
        requiereReemplazo = true;
        tipoReemplazo = "TEMPORAL";
      }

      if (modalidad === "REEMPLAZO_DEFINITIVO") {
        requiereReemplazo = true;
        tipoReemplazo = "DEFINITIVO";
      }

      await updateDoc(
        doc(
          db,
          "garantiasexternas",
          garantia.id
        ),
        {
          modalidad_atencion: modalidad,
          modalidad_definida: true,
          fecha_modalidad: ahora,

          // Los mantenemos por compatibilidad.
          requiere_reemplazo: requiereReemplazo,
          tipo_reemplazo: tipoReemplazo,

          estado: "MODALIDAD_DEFINIDA",

          usermod: users?.correo ?? "",
          fechamod: ahora,
        }
      );

      await cargarDatos();

      await Swal.fire({
        icon: "success",
        title: "Modalidad registrada",
        timer: 1200,
        showConfirmButton: false,
      });

    } catch (error) {
      console.error(
        "Error definiendo modalidad:",
        error
      );

      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "No fue posible guardar la modalidad de atención.",
      });

    } finally {
      setSavingModalidad(false);
    }
  };

  const registrarEnvioProveedor = async () => {
    if (!garantia?.id) return;

    if (!guiaEnvio.trim()) {
      await Swal.fire({
        icon: "warning",
        title: "Falta guía de despacho",
        text: "Debes ingresar el número de guía o documento asociado al envío.",
      });

      return;
    }

    const result = await Swal.fire({
      icon: "question",
      title: "Confirmar envío",
      text: "El equipo original quedará registrado como enviado al ST externo.",
      showCancelButton: true,
      confirmButtonText: "Confirmar envío",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    setSavingEnvio(true);

    try {
      const ahora = new Date();

      await updateDoc(
        doc(
          db,
          "garantiasexternas",
          garantia.id
        ),
        {
          enviado_proveedor: true,
          fecha_envio_proveedor: ahora,

          guia_envio: guiaEnvio.trim(),
          observacion_envio:
            observacionEnvio.trim(),

          estado: "ENVIADO_PROVEEDOR",

          usuario_envio:
            users?.correo ?? "",

          usermod:
            users?.correo ?? "",

          fechamod: ahora,
        }
      );

      setOpenEnvio(false);
      setGuiaEnvio("");
      setObservacionEnvio("");

      await cargarDatos();

      await Swal.fire({
        icon: "success",
        title: "Envío registrado",
        text: "El equipo quedó registrado como enviado al ST externo.",
        timer: 1400,
        showConfirmButton: false,
      });

    } catch (error) {
      console.error(
        "Error registrando envío:",
        error
      );

      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "No fue posible registrar el envío.",
      });

    } finally {
      setSavingEnvio(false);
    }
  };

  const registrarRecepcionProveedor = async () => {
    if (!garantia?.id) return;

    const result = await Swal.fire({
      icon: "question",
      title: "Confirmar recepción",
      text: "Se registrará que el proveedor externo recibió el equipo.",
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    setSavingRecepcion(true);

    try {
      const ahora = new Date();

      await updateDoc(
        doc(db, "garantiasexternas", garantia.id),
        {
          recibido_proveedor: true,
          fecha_recepcion_proveedor: ahora,
          observacion_recepcion: observacionRecepcion.trim(),

          estado: "RECIBIDO_PROVEEDOR",

          usuario_recepcion: users?.correo ?? "",
          usermod: users?.correo ?? "",
          fechamod: ahora,
        }
      );

      setOpenRecepcionProveedor(false);
      setObservacionRecepcion("");
      await cargarDatos();
      await Swal.fire({
        icon: "success",
        title: "Recepción registrada",
        text: "El proveedor quedó registrado como receptor del equipo.",
        timer: 1400,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error registrando recepción proveedor:", error);

      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "No fue posible registrar la recepción del proveedor.",
      });
    } finally {
      setSavingRecepcion(false);
    }
  };

  const registrarSeguimientoProveedor = async () => {
    if (!garantia?.id) return;

    if (!nuevoEstadoProveedor) {
      await Swal.fire({
        icon: "warning",
        title: "Seleccione un estado",
        text: "Debes indicar el nuevo estado informado por el proveedor.",
      });
      return;
    }

    const estadoSeleccionado =
      estadosProveedorOptions.find(
        (item) => item.value === nuevoEstadoProveedor
      );

    const result = await Swal.fire({
      icon: "question",
      title: "Registrar seguimiento",
      text: `El caso cambiará a "${estadoSeleccionado?.text || nuevoEstadoProveedor
        }".`,
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;
    setSavingSeguimiento(true);
    try {
      const ahora = new Date();
      const batch = writeBatch(db);
      // --------------------------------------------------
      // 1. Crear registro histórico
      // --------------------------------------------------
      const bitacoraRef = doc(
        collection(db, "garantiasexternasbitacora")
      );

      batch.set(bitacoraRef, {
        emp_id: users?.emp_id ?? "",

        id_garantia_externa: garantia.id,
        id_cab_inst: garantia.id_cab_inst ?? "",

        estado_anterior: garantia.estado ?? "",
        estado: nuevoEstadoProveedor,

        observacion: observacionSeguimiento.trim(),

        fecha: ahora,

        useradd: users?.correo ?? "",
        fechaadd: ahora,
      });

      // --------------------------------------------------
      // 2. Actualizar estado actual del caso
      // --------------------------------------------------
      batch.update(
        doc(db, "garantiasexternas", garantia.id),
        {
          estado: nuevoEstadoProveedor,

          usermod: users?.correo ?? "",
          fechamod: ahora,
        }
      );

      await batch.commit();

      setOpenSeguimiento(false);
      setNuevoEstadoProveedor("");
      setObservacionSeguimiento("");

      await cargarDatos();

      await Swal.fire({
        icon: "success",
        title: "Seguimiento registrado",
        timer: 1200,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(
        "Error registrando seguimiento proveedor:",
        error
      );

      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "No fue posible registrar el seguimiento del proveedor.",
      });
    } finally {
      setSavingSeguimiento(false);
    }
  };

  const getEstadosPermitidos = (estadoActual) => {
    switch (estadoActual) {
      case "RECIBIDO_PROVEEDOR":
        return [
          {
            key: "EN_DIAGNOSTICO",
            value: "EN_DIAGNOSTICO",
            text: "En diagnóstico",
          },
        ];

      case "EN_DIAGNOSTICO":
        return [
          {
            key: "EN_REPARACION",
            value: "EN_REPARACION",
            text: "En reparación",
          },
        ];

      case "EN_REPARACION":
        return [
          {
            key: "EN_PRUEBAS",
            value: "EN_PRUEBAS",
            text: "En pruebas",
          },
        ];

      case "EN_PRUEBAS":
        return [
          {
            key: "LISTO_RETIRO",
            value: "LISTO_RETIRO",
            text: "Listo para retiro",
          },
        ];

      default:
        return [];
    }
  };

  const estadosProveedorOptions =
    getEstadosPermitidos(garantia?.estado);

  const registrarRecepcionST = async () => {
    if (!garantia?.id) return;

    const result = await Swal.fire({
      icon: "question",
      title: "Confirmar recepción en ST",
      text: "¿Confirmas que el equipo fue retirado del proveedor y recibido nuevamente en Servicio Técnico?",
      showCancelButton: true,
      confirmButtonText: "Sí, confirmar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    setSavingRecepcionST(true);

    try {
      const ahora = new Date();
      const batch = writeBatch(db);

      // Historial
      const bitacoraRef = doc(
        collection(db, "garantiasexternasbitacora")
      );

      batch.set(bitacoraRef, {
        emp_id: users?.emp_id ?? "",
        id_garantia_externa: garantia.id,
        id_cab_inst: garantia.id_cab_inst ?? "",

        estado_anterior: garantia.estado ?? "",
        estado: "RECIBIDO_ST",

        observacion: observacionRecepcionST.trim(),

        fecha: ahora,

        useradd: users?.correo ?? "",
        fechaadd: ahora,
      });

      // Estado actual de la garantía externa
      batch.update(
        doc(db, "garantiasexternas", garantia.id),
        {
          estado: "RECIBIDO_ST",

          recibido_st: true,
          fecha_recepcion_st: ahora,
          observacion_recepcion_st:
            observacionRecepcionST.trim(),

          usuario_recepcion_st: users?.correo ?? "",

          usermod: users?.correo ?? "",
          fechamod: ahora,
        }
      );

      await batch.commit();

      setOpenRecepcionST(false);
      setObservacionRecepcionST("");

      await cargarDatos();

      await Swal.fire({
        icon: "success",
        title: "Equipo recibido",
        text: "La recepción del equipo en ST fue registrada correctamente.",
      });
    } catch (error) {
      console.error("Error registrando recepción en ST:", error);

      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "No fue posible registrar la recepción del equipo.",
      });
    } finally {
      setSavingRecepcionST(false);
    }
  };

  const estadosProveedor = [
    "RECIBIDO_PROVEEDOR",
    "EN_DIAGNOSTICO",
    "EN_REPARACION",
    "EN_PRUEBAS",
    "LISTO_RETIRO",
  ];

  const indiceProveedor = estadosProveedor.indexOf(
    garantia?.estado
  );

  const etapaActual = (() => {
    if (!garantia?.modalidad_definida) return 0;

    if (
      garantia.estado === "MODALIDAD_DEFINIDA"
    ) {
      return 1;
    }

    if (garantia.estado === "ENVIADO_PROVEEDOR") {
      return 1;
    }

    if (
      [
        "RECIBIDO_PROVEEDOR",
        "EN_DIAGNOSTICO",
        "EN_REPARACION",
        "EN_PRUEBAS",
        "LISTO_RETIRO",
      ].includes(garantia.estado)
    ) {
      return 2;
    }

    if (garantia.estado === "RECIBIDO_ST") {
      return 3;
    }

    if (
      ["REALIZADO", "ENTREGADO"].includes(
        garantia.estado
      )
    ) {
      return 4;
    }

    return 0;
  })();

  const etapas = [
    {
      nombre: "Modalidad",
      icono: "exchange",
    },
    {
      nombre: "Envío",
      icono: "shipping fast",
    },
    {
      nombre: "Proveedor",
      icono: "wrench",
    },
    {
      nombre: "Retorno ST",
      icono: "warehouse",
    },
    {
      nombre: "Finalización",
      icono: "check circle",
    },
  ];

  return (
    <Container
      style={{
        maxWidth: 1400,
        paddingTop: 20,
        paddingBottom: 40,
      }}
    >
      {/* ====================================================== */}
      {/* HEADER */}
      {/* ====================================================== */}

      <Segment
        raised
        color="violet"
      >
        <Grid
          verticalAlign="middle"
          stackable
        >
          <Grid.Row>
            <Grid.Column width={11}>
              <Header
                as="h2"
                color="violet"
              >
                <Icon name="shipping fast" />

                <Header.Content>
                  Garantía Externa

                  <Header.Subheader>
                    Gestión y seguimiento con
                    proveedor externo
                  </Header.Subheader>
                </Header.Content>
              </Header>
            </Grid.Column>

            <Grid.Column
              width={5}
              textAlign="right"
            >
              <Label
                color={estadoUI.color}
                size="large"
              >
                <Icon
                  name={estadoUI.icon}
                />

                {estadoUI.text}
              </Label>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>

      {/* ====================================================== */}
      {/* RESUMEN DEL CASO */}
      {/* ====================================================== */}

      <Segment raised>
        <Grid stackable verticalAlign="middle">
          <Grid.Row>
            <Grid.Column width={4}>
              <strong>Orden ingreso</strong>
              <div style={{ fontSize: 18 }}>
                #{garantia.folio_ingreso || ingreso?.folio || "—"}
              </div>
            </Grid.Column>

            <Grid.Column width={4}>
              <strong>Cliente</strong>
              <div>
                {garantia.cliente ||
                  ingreso?.entidad ||
                  "—"}
              </div>
            </Grid.Column>

            <Grid.Column width={4}>
              <strong>Equipo</strong>
              <div>
                {garantia.marca || "—"}{" "}
                {garantia.modelo || ""}
              </div>
              <small>
                Serie: {garantia.serie || "—"}
              </small>
            </Grid.Column>

            <Grid.Column width={4}>
              <strong>Proveedor</strong>
              <div>
                {garantia.proveedor || "—"}
              </div>

              {garantia.modalidad_atencion && (
                <Label
                  basic
                  color="blue"
                  size="tiny"
                  style={{ marginTop: 5 }}
                >
                  {garantia.modalidad_atencion
                    .replaceAll("_", " ")}
                </Label>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>


      {/* ====================================================== */}
      {/* FLUJO PRINCIPAL */}
      {/* ====================================================== */}

      <Segment raised>
        <Header as="h3">
          <Icon name="sitemap" />
          Estado del proceso
        </Header>

        <Divider />

        <Grid
          columns={5}
          stackable
          textAlign="center"
          verticalAlign="middle"
        >
          <Grid.Row>
            {etapas.map((etapa, index) => {
              const completada = index < etapaActual;
              const actual = index === etapaActual;

              return (
                <Grid.Column key={etapa.nombre}>
                  <div
                    style={{
                      padding: 12,
                      borderRadius: 8,
                      border: actual
                        ? "2px solid #2185d0"
                        : "1px solid #ddd",
                      background: completada
                        ? "#f3fff5"
                        : actual
                          ? "#f4f9ff"
                          : "#fafafa",
                      minHeight: 92,
                    }}
                  >
                    <Icon
                      name={
                        completada
                          ? "check circle"
                          : etapa.icono
                      }
                      color={
                        completada
                          ? "green"
                          : actual
                            ? "blue"
                            : "grey"
                      }
                      size="large"
                    />

                    <div
                      style={{
                        marginTop: 8,
                        fontWeight: actual
                          ? "bold"
                          : "normal",
                      }}
                    >
                      {etapa.nombre}
                    </div>

                    {completada && (
                      <Label
                        color="green"
                        size="mini"
                        style={{ marginTop: 5 }}
                      >
                        COMPLETADO
                      </Label>
                    )}

                    {actual && (
                      <Label
                        color="blue"
                        size="mini"
                        style={{ marginTop: 5 }}
                      >
                        ACTUAL
                      </Label>
                    )}
                  </div>
                </Grid.Column>
              );
            })}
          </Grid.Row>
        </Grid>


        {/* SUBFLUJO DEL PROVEEDOR */}

        {indiceProveedor >= 0 && (
          <>
            <Divider />

            <Header as="h4" textAlign="center">
              Proceso del proveedor
            </Header>

            <Grid
              columns={5}
              textAlign="center"
              verticalAlign="middle"
            >
              <Grid.Row>
                {[
                  ["Recibido", "RECIBIDO_PROVEEDOR"],
                  ["Diagnóstico", "EN_DIAGNOSTICO"],
                  ["Reparación", "EN_REPARACION"],
                  ["Pruebas", "EN_PRUEBAS"],
                  ["Listo retiro", "LISTO_RETIRO"],
                ].map(([texto, estado], index) => {
                  const completado =
                    index < indiceProveedor;

                  const actual =
                    garantia.estado === estado;

                  return (
                    <Grid.Column key={estado}>
                      <Icon
                        name={
                          completado
                            ? "check circle"
                            : actual
                              ? "dot circle"
                              : "circle outline"
                        }
                        color={
                          completado
                            ? "green"
                            : actual
                              ? "blue"
                              : "grey"
                        }
                      />

                      <div
                        style={{
                          fontSize: 12,
                          marginTop: 5,
                          fontWeight: actual
                            ? "bold"
                            : "normal",
                        }}
                      >
                        {texto}
                      </div>
                    </Grid.Column>
                  );
                })}
              </Grid.Row>
            </Grid>
          </>
        )}
      </Segment>


      {/* ====================================================== */}
      {/* ACCIÓN ACTUAL */}
      {/* ====================================================== */}

      <Segment
        raised
        color={estadoUI.color}
      >
        <Header as="h3">
          <Icon name={estadoUI.icon} />

          <Header.Content>
            Estado actual: {estadoUI.text}

            <Header.Subheader>
              Acción requerida para continuar el proceso
            </Header.Subheader>
          </Header.Content>
        </Header>

        <Divider />


        {/* MODALIDAD */}

        {!garantia.modalidad_definida && (
          <>
            <Message info>
              Define cómo será atendido el cliente
              mientras se resuelve la garantía del
              equipo original.
            </Message>

            <Grid
              columns={3}
              stackable
              textAlign="center"
            >
              <Grid.Column>
                <Button
                  fluid
                  color="blue"
                  loading={savingModalidad}
                  disabled={savingModalidad}
                  onClick={() =>
                    definirModalidadAtencion(
                      "ESPERA_REPARACION"
                    )
                  }
                >
                  <Icon name="clock outline" />
                  Puede esperar reparación
                </Button>
              </Grid.Column>

              <Grid.Column>
                <Button
                  fluid
                  color="orange"
                  loading={savingModalidad}
                  disabled={savingModalidad}
                  onClick={() =>
                    definirModalidadAtencion(
                      "PRESTAMO_TEMPORAL"
                    )
                  }
                >
                  <Icon name="exchange" />
                  Préstamo temporal
                </Button>
              </Grid.Column>

              <Grid.Column>
                <Button
                  fluid
                  color="green"
                  loading={savingModalidad}
                  disabled={savingModalidad}
                  onClick={() =>
                    definirModalidadAtencion(
                      "REEMPLAZO_DEFINITIVO"
                    )
                  }
                >
                  <Icon name="box" />
                  Reemplazo definitivo
                </Button>
              </Grid.Column>
            </Grid>
          </>
        )}


        {/* MODALIDAD DEFINIDA - FALTA ENVÍO */}

        {garantia.modalidad_definida &&
          !garantia.enviado_proveedor && (
            <>
              <Message info>
                Modalidad:{" "}
                <strong>
                  {garantia.modalidad_atencion
                    ?.replaceAll("_", " ")}
                </strong>
              </Message>

              <p>
                El siguiente paso es registrar el envío
                del equipo original al servicio técnico
                externo.
              </p>

              <Button
                color="violet"
                icon
                labelPosition="left"
                onClick={() => setOpenEnvio(true)}
              >
                <Icon name="shipping fast" />
                Registrar envío a ST externo
              </Button>
            </>
          )}


        {/* ENVIADO */}

        {garantia.estado ===
          "ENVIADO_PROVEEDOR" && (
            <>
              <p>
                El equipo fue enviado al proveedor con
                guía{" "}
                <strong>
                  {garantia.guia_envio || "—"}
                </strong>.
              </p>

              <Button
                color="orange"
                icon
                labelPosition="left"
                onClick={() =>
                  setOpenRecepcionProveedor(true)
                }
              >
                <Icon name="check circle" />
                Confirmar recepción proveedor
              </Button>
            </>
          )}


        {/* SEGUIMIENTO PROVEEDOR */}

        {[
          "RECIBIDO_PROVEEDOR",
          "EN_DIAGNOSTICO",
          "EN_REPARACION",
          "EN_PRUEBAS",
        ].includes(garantia.estado) && (
            <>
              <p>
                El equipo se encuentra actualmente en:
              </p>

              <Label color="blue" size="large">
                {garantia.estado.replaceAll("_", " ")}
              </Label>

              <Divider />

              <Button
                primary
                icon
                labelPosition="left"
                onClick={() =>
                  setOpenSeguimiento(true)
                }
              >
                <Icon name="plus circle" />
                Registrar siguiente estado
              </Button>
            </>
          )}


        {/* LISTO PARA RETIRO */}

        {garantia.estado === "LISTO_RETIRO" && (
          <>
            <Message positive>
              <Message.Header>
                Reparación terminada por proveedor
              </Message.Header>

              <p>
                El equipo se encuentra disponible para
                retiro desde el ST externo.
              </p>
            </Message>

            <p>
              <strong>Proveedor:</strong>{" "}
              {garantia.proveedor || "—"}
            </p>

            <p>
              <strong>Equipo:</strong>{" "}
              {garantia.marca || ""}{" "}
              {garantia.modelo || ""} · Serie{" "}
              {garantia.serie || "—"}
            </p>

            <Button
              color="teal"
              icon
              labelPosition="left"
              onClick={() =>
                setOpenRecepcionST(true)
              }
            >
              <Icon name="warehouse" />
              Registrar recepción en ST
            </Button>
          </>
        )}


        {/* RECIBIDO ST - LO USAREMOS EN EL SIGUIENTE PASO */}

        {garantia.estado === "RECIBIDO_ST" && (
          <Message positive>
            <Message.Header>
              Equipo recibido en Servicio Técnico
            </Message.Header>

            <p>
              El equipo ya fue recuperado desde el
              proveedor externo.
            </p>
          </Message>
        )}
      </Segment>


      {/* ====================================================== */}
      {/* DETALLES DESPLEGABLES */}
      {/* ====================================================== */}

      <Segment>
        <Button
          basic
          fluid
          textAlign="left"
          onClick={() =>
            setShowDetalles(!showDetalles)
          }
        >
          <Icon
            name={
              showDetalles
                ? "chevron down"
                : "chevron right"
            }
          />

          Información detallada del caso
        </Button>

        {showDetalles && (
          <>
            <Divider />

            <Grid columns={3} stackable>
              <Grid.Row>
                <Grid.Column>
                  <Header as="h5">
                    <Icon name="user outline" />
                    Cliente
                  </Header>

                  <p>
                    <strong>Nombre:</strong>{" "}
                    {garantia.cliente ||
                      ingreso?.entidad ||
                      "—"}
                  </p>

                  <p>
                    <strong>RUT:</strong>{" "}
                    {garantia.cliente_rut ||
                      ingreso?.rut ||
                      "—"}
                  </p>
                </Grid.Column>

                <Grid.Column>
                  <Header as="h5">
                    <Icon name="microchip" />
                    Equipo
                  </Header>

                  <p>
                    {garantia.familia || "—"} /{" "}
                    {garantia.tipo || "—"}
                  </p>

                  <p>
                    {garantia.marca || "—"}{" "}
                    {garantia.modelo || ""}
                  </p>

                  <p>
                    <strong>Serie:</strong>{" "}
                    {garantia.serie || "—"}
                  </p>
                </Grid.Column>

                <Grid.Column>
                  <Header as="h5">
                    <Icon name="building outline" />
                    Proveedor
                  </Header>

                  <p>
                    <strong>
                      {garantia.proveedor || "—"}
                    </strong>
                  </p>

                  <p>
                    RUT:{" "}
                    {garantia.proveedor_rut || "—"}
                  </p>

                  <p>
                    Contacto:{" "}
                    {garantia.proveedor_contacto ||
                      "—"}
                  </p>

                  <p>
                    Teléfono:{" "}
                    {garantia.proveedor_telefono ||
                      "—"}
                  </p>

                  <p>
                    Correo:{" "}
                    {garantia.proveedor_correo ||
                      "—"}
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </>
        )}
      </Segment>


      {/* ====================================================== */}
      {/* HISTORIAL DESPLEGABLE */}
      {/* ====================================================== */}

      <Segment>
        <Button
          basic
          fluid
          onClick={() =>
            setShowHistorial(!showHistorial)
          }
        >
          <Icon
            name={
              showHistorial
                ? "chevron down"
                : "chevron right"
            }
          />

          Historial del proveedor (
          {bitacoraProveedor.length})
        </Button>

        {showHistorial && (
          <>
            <Divider />

            {bitacoraProveedor.length === 0 ? (
              <Message>
                Todavía no existen movimientos
                registrados.
              </Message>
            ) : (
              <Table
                celled
                compact
                striped
                stackable
              >
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>
                      Fecha
                    </Table.HeaderCell>

                    <Table.HeaderCell>
                      Estado anterior
                    </Table.HeaderCell>

                    <Table.HeaderCell>
                      Nuevo estado
                    </Table.HeaderCell>

                    <Table.HeaderCell>
                      Observación
                    </Table.HeaderCell>

                    <Table.HeaderCell>
                      Usuario
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {bitacoraProveedor.map(
                    (item) => (
                      <Table.Row key={item.id}>
                        <Table.Cell>
                          {item.fecha?.toDate
                            ? moment(
                              item.fecha.toDate()
                            ).format(
                              "DD/MM/YYYY HH:mm"
                            )
                            : "—"}
                        </Table.Cell>

                        <Table.Cell>
                          <Label basic>
                            {item.estado_anterior
                              ? item.estado_anterior.replaceAll(
                                "_",
                                " "
                              )
                              : "—"}
                          </Label>
                        </Table.Cell>

                        <Table.Cell>
                          <Label color="blue">
                            {item.estado
                              ? item.estado.replaceAll(
                                "_",
                                " "
                              )
                              : "—"}
                          </Label>
                        </Table.Cell>

                        <Table.Cell>
                          {item.observacion || "—"}
                        </Table.Cell>

                        <Table.Cell>
                          {item.useradd || "—"}
                        </Table.Cell>
                      </Table.Row>
                    )
                  )}
                </Table.Body>
              </Table>
            )}
          </>
        )}
      </Segment>


      {/* ====================================================== */}
      {/* DOCUMENTOS */}
      {/* ====================================================== */}

      <Segment>
        <Button
          basic
          fluid
          onClick={() =>
            setShowDocumentos(!showDocumentos)
          }
        >
          <Icon
            name={
              showDocumentos
                ? "chevron down"
                : "chevron right"
            }
          />

          Documentos
        </Button>

        {showDocumentos && (
          <>
            <Divider />

            {garantia.guia_envio ? (
              <Table basic="very" compact>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell width={5}>
                      <Icon name="file alternate outline" />
                      Guía envío a proveedor
                    </Table.Cell>

                    <Table.Cell>
                      <strong>
                        {garantia.guia_envio}
                      </strong>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            ) : (
              <Message>
                No existen documentos registrados.
              </Message>
            )}
          </>
        )}
      </Segment>

      <Modal
        open={openEnvio}
        onClose={() => {
          if (!savingEnvio) {
            setOpenEnvio(false);
          }
        }}
        size="small"
      >
        <Modal.Header>
          Registrar envío a ST externo
        </Modal.Header>

        <Modal.Content>
          <Message info>
            El equipo original será registrado
            como enviado al proveedor externo
            responsable de la garantía.
          </Message>

          <Form>
            <Form.Field>
              <label>Proveedor</label>

              <input
                value={
                  garantia?.proveedor || ""
                }
                disabled
              />
            </Form.Field>

            <Form.Field>
              <label>Equipo</label>

              <input
                value={`${garantia?.marca || ""} ${garantia?.modelo || ""
                  } - Serie ${garantia?.serie || ""
                  }`}
                disabled
              />
            </Form.Field>

            <Form.Field required>
              <label>
                N° Guía / Documento de envío
              </label>

              <input
                placeholder="Ej: GD-12345"
                value={guiaEnvio}
                onChange={(e) =>
                  setGuiaEnvio(
                    e.target.value
                  )
                }
                disabled={savingEnvio}
              />
            </Form.Field>

            <Form.TextArea
              label="Observación"
              placeholder="Observaciones del envío..."
              value={observacionEnvio}
              onChange={(e, { value }) =>
                setObservacionEnvio(
                  value
                )
              }
              disabled={savingEnvio}
            />
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button
            onClick={() =>
              setOpenEnvio(false)
            }
            disabled={savingEnvio}
          >
            Cancelar
          </Button>

          <Button
            color="violet"
            icon
            labelPosition="right"
            loading={savingEnvio}
            disabled={savingEnvio}
            onClick={
              registrarEnvioProveedor
            }
          >
            Confirmar envío
            <Icon name="shipping fast" />
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        open={openRecepcionProveedor}
        onClose={() => {
          if (!savingRecepcion) {
            setOpenRecepcionProveedor(false);
          }
        }}
        size="small"
      >
        <Modal.Header>
          Confirmar recepción del proveedor
        </Modal.Header>

        <Modal.Content>
          <Message info>
            Se registrará que el ST externo recibió físicamente el equipo.
          </Message>

          <Form>
            <Form.Field>
              <label>Proveedor</label>

              <input
                value={garantia?.proveedor || ""}
                disabled
              />
            </Form.Field>

            <Form.Field>
              <label>Equipo</label>

              <input
                value={`${garantia?.marca || ""} ${garantia?.modelo || ""
                  } - Serie ${garantia?.serie || ""}`}
                disabled
              />
            </Form.Field>

            <Form.Field>
              <label>Guía de envío</label>

              <input
                value={garantia?.guia_envio || ""}
                disabled
              />
            </Form.Field>

            <Form.TextArea
              label="Observación de recepción"
              placeholder="Ej: Proveedor confirma recepción conforme..."
              value={observacionRecepcion}
              onChange={(e, { value }) =>
                setObservacionRecepcion(value)
              }
              disabled={savingRecepcion}
            />
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button
            onClick={() => setOpenRecepcionProveedor(false)}
            disabled={savingRecepcion}
          >
            Cancelar
          </Button>

          <Button
            color="orange"
            icon
            labelPosition="right"
            loading={savingRecepcion}
            disabled={savingRecepcion}
            onClick={registrarRecepcionProveedor}
          >
            Confirmar recepción
            <Icon name="check circle" />
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        open={openSeguimiento}
        onClose={() => {
          if (!savingSeguimiento) {
            setOpenSeguimiento(false);
          }
        }}
        size="small"
      >
        <Modal.Header>
          Seguimiento del proveedor externo
        </Modal.Header>

        <Modal.Content>
          <Message info>
            Registra el estado informado por el servicio técnico externo.
          </Message>

          <Form>
            <Form.Field>
              <label>Proveedor</label>

              <input
                value={garantia?.proveedor || ""}
                disabled
              />
            </Form.Field>

            <Form.Field>
              <label>Estado actual</label>

              <input
                value={
                  garantia?.estado
                    ? garantia.estado.replaceAll("_", " ")
                    : ""
                }
                disabled
              />
            </Form.Field>

            <Form.Field required>
              <label>Nuevo estado</label>

              <Dropdown
                placeholder="Seleccionar estado"
                fluid
                selection
                options={estadosProveedorOptions}
                value={nuevoEstadoProveedor}
                onChange={(e, { value }) =>
                  setNuevoEstadoProveedor(value)
                }
                disabled={savingSeguimiento}
              />
            </Form.Field>

            <Form.TextArea
              label="Observación"
              placeholder="Ej: Proveedor informa que comenzó el diagnóstico del equipo..."
              value={observacionSeguimiento}
              onChange={(e, { value }) =>
                setObservacionSeguimiento(value)
              }
              disabled={savingSeguimiento}
            />
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button
            onClick={() => {
              setOpenSeguimiento(false);
              setNuevoEstadoProveedor("");
              setObservacionSeguimiento("");
            }}
            disabled={savingSeguimiento}
          >
            Cancelar
          </Button>

          <Button
            primary
            icon
            labelPosition="right"
            loading={savingSeguimiento}
            disabled={
              savingSeguimiento ||
              !nuevoEstadoProveedor
            }
            onClick={registrarSeguimientoProveedor}
          >
            Registrar
            <Icon name="check" />
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        open={openRecepcionST}
        onClose={() => {
          if (!savingRecepcionST) {
            setOpenRecepcionST(false);
          }
        }}
        size="small"
      >
        <Modal.Header>
          Recepción desde proveedor
        </Modal.Header>

        <Modal.Content>
          <Message info>
            Registra la recepción física del equipo reparado
            desde el servicio técnico externo.
          </Message>

          <Form>
            <Form.Field>
              <label>Proveedor</label>
              <input
                value={garantia?.proveedor || ""}
                disabled
              />
            </Form.Field>

            <Form.Field>
              <label>Equipo recibido</label>
              <input
                value={`${garantia?.marca || ""} ${garantia?.modelo || ""
                  } - Serie ${garantia?.serie || ""}`}
                disabled
              />
            </Form.Field>

            <Form.TextArea
              label="Observación de recepción"
              placeholder="Ej: Equipo recibido reparado y en buenas condiciones..."
              value={observacionRecepcionST}
              onChange={(e, { value }) =>
                setObservacionRecepcionST(value)
              }
              disabled={savingRecepcionST}
            />
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button
            onClick={() => {
              setOpenRecepcionST(false);
              setObservacionRecepcionST("");
            }}
            disabled={savingRecepcionST}
          >
            Cancelar
          </Button>

          <Button
            color="teal"
            loading={savingRecepcionST}
            disabled={savingRecepcionST}
            onClick={registrarRecepcionST}
          >
            <Icon name="check" />
            Confirmar recepción
          </Button>
        </Modal.Actions>
      </Modal>

    </Container>
  );
};

export default GestionGarantiaExterna;